import { render, staticRenderFns } from "./LossReasonModal.vue?vue&type=template&id=06eb1558&scoped=true&"
import script from "./LossReasonModal.vue?vue&type=script&lang=js&"
export * from "./LossReasonModal.vue?vue&type=script&lang=js&"
import style0 from "./LossReasonModal.vue?vue&type=style&index=0&id=06eb1558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06eb1558",
  null
  
)

export default component.exports